import { devConfiguration } from './config.dev';
import { prodConfiguration} from './config.prod';

let env = 'development';
// let env = "production";
export const endpoints =
	env === 'development' ? devConfiguration : prodConfiguration;
